import { ReactComponent as ExclamationPoint } from "../../assets/icons/exclamation-point.svg";
import { ReactComponent as Check } from "../../assets/icons/check.svg";

import "./TrackingSection.scss";
import {
  getReachedStep,
  isLastEventError,
  isSectionError,
  isSectionWarning,
} from "./FormatEventsFunc";

const TrackingLine = (props) => {
  const reachedStep = getReachedStep(props.trackingEvents);
  const isLastEventOK =
    props.trackingEvents[props.trackingEvents.length - 1].status === "ok";
  // const isError = isLastEventError(props.trackingEvents);
  return (
    <div className="tracking-line">
      {props.trackingSections.map((section, i) => {
        const isChecked = section.id <= reachedStep;
        const sectionEvents = props.trackingEvents.filter(
          (event) => event.stepCode === section.id
        );
        const isError = isSectionError(props.trackingEvents, section.id);
        const isWarning = isSectionWarning(props.trackingEvents, section.id);
        console.log("section length", section.title.props.label);
        return (
          <div key={section.id} className="tracking-steps">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className="tracking-dot"
                style={{
                  // backgroundColor: isChecked
                  //   ? "#51f8a8"
                  //   : sectionEvents.length > 0
                  //   ? "#111"
                  //   : "#ddd",
                  backgroundColor:
                    isLastEventOK && isChecked
                      ? "#51f8a8"
                      : isWarning
                      ? "#001A4C"
                      : isError
                      ? "#001A4C"
                      : isChecked
                      ? "#51f8a8"
                      : "#ddd",
                }}
              >
                {(isLastEventOK && isChecked) ||
                (isChecked && !isWarning && !isError) ? (
                  <>
                    {section.icon}
                    <div
                      className="apex-dot"
                      style={{ backgroundColor: "#001A4C" }}
                    >
                      <Check
                        width={12}
                        height={12}
                        style={{ stroke: "white" }}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    {section.iconWhite}
                    {sectionEvents.length > 0 && (
                      <div
                        className="apex-dot"
                        style={{
                          backgroundColor: isError ? "crimson" : "#ff7f00",
                        }}
                      >
                        <ExclamationPoint width={24} height={24} />
                      </div>
                    )}
                  </>
                )}
              </div>
              {section.title && (
                <div className="tracking-title">{section.title}</div>
              )}
            </div>
            {i < props.trackingSections.length - 1 && (
              <div
                className="line"
                style={{
                  // backgroundColor: isChecked
                  //   ? "#51f8a8"
                  //   : sectionEvents.length > 0
                  //   ? "#111"
                  //   : "#ddd",
                  backgroundColor:
                    isLastEventOK && isChecked
                      ? "#51f8a8"
                      : isWarning
                      ? "#001A4C"
                      : isError
                      ? "#001A4C"
                      : isChecked
                      ? "#51f8a8"
                      : "#ddd",
                }}
              ></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TrackingLine;
